import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, palette, spacing }) => ({
  contentGrid: {
    display: 'grid',
    gridTemplateAreas: `
        "breadcrumbs breadcrumbs breadcrumbs"
        "header      header      header"
        "leftPanel   content     rightPanel"
      `,
    gridTemplateColumns: '1fr 660px 1fr',
    [breakpoints.down('lg')]: {
      gridTemplateAreas: `
      "breadcrumbs"
      "header"
      "content"
      "rightPanel"
    `,
      gridTemplateColumns: '100%'
    },
    overflowX: 'hidden'
  },
  playlistNavContainer: {
    marginTop: '-100px'
  },
  header: {
    gridArea: 'header',
    marginTop: spacing(0)
  },
  headerPlaylist: {
    background: palette.grey.shade[5]
  },
  leftPanel: {
    gridArea: 'leftPanel'
  },
  rightPanel: {
    gridArea: 'rightPanel',
    [breakpoints.down('lg')]: {
      paddingRight: spacing(2)
    }
  },
  content: {
    gridArea: 'content'
  },
  breadcrumbs: {
    gridArea: 'breadcrumbs'
  },
  container: {
    paddingTop: spacing(2),
    paddingBottom: spacing(2)
  },
  article: {
    '& img': {
      maxHeight: '100%',
      maxWidth: '100%',
      objectFit: 'contain'
    }
  }
}))
